import { isValid, startOfDay } from 'date-fns'

// Today as `yyyy-MM-dd` for the `min` attribute on a native date input. The browser uses
// it to grey out past days in its picker; the validator below is what actually enforces.
export const todayDateInputValue = (): string => {
  const today = startOfDay(new Date())
  const year = today.getFullYear().toString().padStart(4, '0')
  const month = (today.getMonth() + 1).toString().padStart(2, '0')
  const day = today.getDate().toString().padStart(2, '0')
  return `${year}-${month}-${day}`
}

// Validator shared by the CDR/CNS expiration date and each state-licence expiration date:
// a credential that's already expired (or not a real date) is never acceptable.
export const validateFutureExpiration = (
  value: Date | null | undefined,
  missingMessage: string
): string | undefined => {
  if (!value || !isValid(value)) return missingMessage
  return value >= startOfDay(new Date()) ? undefined : "Expiration date can't be in the past."
}
